export interface LoadStatusModel {
    isLoading?: boolean,
    isLoaded?: boolean,
    isCanLoadMore?: boolean,
    rootUrl?: string,
    total?: number
}
